import * as React from 'react'
import './../../styles/admin/adminData.css'

export default class AdminData extends React.Component {
  constructor () {
     super()
     this.state = {
       recurringRevenue: '-',
       vehiclesWatched: '-',
       paidAccounts: '-'
     }
   }
  render () {
    return (
      <div className="admin-data-container">
        <div className="admin-data">
          <h4 className="admin-data-top">Recurring Revenue</h4>
          <p className="admin-data-bottom">{this.state.recurringRevenue}</p>
        </div>
        <div className="admin-data">
          <h4 className="admin-data-top">Vehicles Watched</h4>
          <p className="admin-data-bottom">{this.state.vehiclesWatched}</p>
        </div>
        <div className="admin-data">
          <h4 className="admin-data-top">Total Paid Accounts</h4>
          <p className="admin-data-bottom">{this.state.paidAccounts}</p>
        </div>
        <div className="admin-data">
          <h4 className="admin-data-top">Date Range</h4>
          <p className="admin-data-bottom">-</p>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/adminData.js